<template>
  <div>
    <main>
      <div class="container">
        <div class="row">
          <div class="col_xl_12 col_l_12 col_m_12 col_s_12">
            <img
                src="@/assets/img/mail_icon.svg"
                alt=""
                class="error_icon"
                v-if="user.email_verified"
            />

            <div v-if="user.email != null">
              <template v-if="user.email_verified">
                <p class="tac terms_title">Email address verified</p>

                <p class="tac">Thank you for verifying your email address!</p>

                <router-link
                    to="/user_rooms"
                    class="hover_op color_btn return_home"
                >
                  I’m in!
                </router-link>
              </template>

              <div v-else class="verify_wrap">
                <img
                    src="@/assets/img/welcome_icon.svg"
                    alt=""
                    class="error_icon"
                />
                <p class="tac terms_title">Welcome to GetSynced</p>

                <p class="tac">
                  You’re almost there! We sent an email to
                  <b>{{ $store.state.user.email }}</b> <br/><br/>

                  Just click on the in that email to complete your signup. If
                  you don’t see it, you may need to check your spam folder.
                </p>

                <button
                    v-on:click="resendVerificationEmail"
                    class="color_btn hover_op return_home"
                >
                  Resend
                </button>
              </div>
            </div>

            <roomInfoScreen v-else :preloader="true"
            >Please wait
            </roomInfoScreen>
          </div>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import roomInfoScreen from "@/components/roomInfoScreen.vue";
import {getAuth, sendEmailVerification} from "firebase/auth";
import apiClient from "../apiClient";

export default {
  name: "AuthCallback",

  components: {
    roomInfoScreen,
  },

  computed: {

    user() {
      return this.$store.state.user;
    },
  },

  methods: {
    async resendVerificationEmail() {
      try {
        await apiClient.post("user/resend-verification-email")
        this.$store.commit("showModal", "verify_send")
      } catch (e) {
        console.error(e);
        this.$store.dispatch("onError", JSON.stringify(e));
      }
    },
  },
};
</script>

<style lang="scss" scoped>
b {
  font-weight: 700;
}

.verify_wrap {
  max-width: 750px;
  margin-left: auto;
  margin-right: auto;
}

.terms_title {
  margin-top: 64px;
  margin-bottom: 32px;
}
</style>
